import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/ContactCustomerservice/contactCustomerservice.container"
    ).then((module) => ({ default: module.ContactCustomerserviceContainer }))
);
